<template>
   <div>
    <div class="hero-section pt-5" >
      <v-layout row wrap align-center justify-center style="max-width: 80%; margin: 0 auto;">
        <v-flex xs12 md6 class="text-xs-center">
            <v-img
                        src="/img/cryp.png"
                        alt="image crypto"
                        max-height="500"
                        contain
                        class="mb-3"
                        style="display: flex;"
                        ></v-img>
        </v-flex>
  
        <v-flex xs12 md6 class=" px-4">
          <h1 class="display-2 font-weight-bold mb-4" style="text-transform: uppercase;">
            ACHETER, VENDRE, ÉCHANGER {{ crypto }}  {{ pays? ` ${prep} ${pays}`: 'EN AFRIQUE'  }}
          </h1>
          <v-card flat class="transparent">
            <v-card-text >
              <p class="subheading">
                Le marché des bitcoins en Franc CFA (XOF) {{ pays? `${prep} ${pays.toUpperCase()}`: 'en Afrique'  }} est en pleine
                expansion, tout comme l'intérêt pour les cryptomonnaies et la
                technologie blockchain.
              </p>
              <p class="subheading">
                Hiropay se positionne comme la solution de choix pour acheter et
                vendre des bitcoins de façon fiable, quel que soit
                le moyen de paiement.
              </p>
              <p class="subheading">
                Grâce à Hiropay, vous pouvez échanger vos {{ crypto.toUpperCase() }} en toute
                sécurité contre une large gamme de services financiers adaptés à
                la région.
              </p>
              <v-btn
                large
                color="white"
                class="teal--text text-none mt-4"
                @click="animateButton"
                :class="{ 'btn-animate': isAnimating }"
                router to="/register"
              >
                Commencer maintenant
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <div  class="grey lighten-4 py-5" >
    <v-layout wrap justify-center style="max-width: 90%; margin: auto;">
      <v-flex xs12 class="text-xs-center mb-5">
        <h2 class="display-1 font-weight-bold">Moyens de Paiement disponibles</h2>
      </v-flex>
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex
            v-for="service in mobileMoneyServices"
            :key="service.name"
            xs12 sm6 md4
            class="pa-3"
          >
            <v-card class="elevation-1 transition-swing">
              <v-card-text>
                <v-img
                  :src="'img' + service.logo"
                  :alt="service.name"
                  height="64"
                  contain
                  class="mb-3"
                  style="display: flex;"
                ></v-img>
                <span class="title font-weight-bold mb-2" style="display: inline-block;">{{ service.name }}</span>
                <div class="grey--text mb-4">{{ service.description }}</div>
                <v-list>
                  <v-list-tile
                    v-for="feature in service.features"
                    :key="feature"
                    avatar
                  >
                    <v-list-tile-action>
                      <v-icon color="success">check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ feature }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>

 
    </div>
    <subFooter />
   </div>
  </template>
  
  <script>
  const subFooter = () => import("../components/subFooter");
import {validCountries} from '../routerParameters'
  export default {
    name: 'HeroSection',
    components: {
        subFooter,
    },

    data() {
      return {
        isAnimating: false,
        mobileMoneyServices: [
        {
  name: 'Orange Money',
  logo: '/orange.svg',
  description: 'Solution de paiement mobile d\'Orange',
  features: [
    'Transfert rapide',
    'Paiement factures',
    'Retrait agences',
    'Envoi à l\'étranger'
  ]
},

{
          name: 'T-Money',
          logo: '/tmoney.png',
          description: 'Service de paiement mobile de Togocom',
          features: [
            'Transfert d\'argent',
            'Paiement de factures',
            'Recharge téléphonique',
            'Paiement marchand'
          ]
        }, 


{
  name: 'Wave',
  logo: '/wave.png',
  description: 'Application de transfert d\'argent et paiements',
  features: [
    'Zéro frais',
    'Paiement QR',
    'Recharge mobile',
    'Gestion facile'
  ]
},
{
  name: 'Moov Money',
  logo: '/moov.png',
  description: 'Service financier mobile de Moov',
  features: [
    'Envoi instantané',
    'Retrait agences',
    'Paiement factures',
    'Achats en ligne'
  ]
},
{
  name: 'MTN Mobile Money',
  logo: '/mtn.svg',
  description: 'Service de portefeuille électronique de MTN',
  features: [
    'Paiement rapide',
    'Recharge facile',
    'Partage MoMo',
    'Retrait simplifié'
  ]
},

{
  name: 'Ecobank Mobile',
  logo: '/ecobank.png',
  description: 'Application bancaire mobile d\'Ecobank',
  features: [
    'Transfert entre comptes',
    'Paiement sécurisé',
    'Recharge mobile',
    'Suivi en temps réel'
  ]
},

        
        {
          name: 'Flooz',
          logo: '/moov.png',
          description: 'Solution de paiement mobile de Moov Africa',
          features: [
            'Transfert national et international',
            'Paiement de services',
            'Achat de crédit',
            'Paiement commerçant'
          ]
        },
       
      ]
      }
    },
    computed: {
        action() {
      return this.$route.params.action || '';
    },
    crypto() {
      return this.$route.params.crypto || '';
    },
    pays() {
      return this.$route.params.pays || '';
    },


    prep(){ 
        return validCountries[this.pays] || 'au';
    },

    pageTitle() {
      // Extraire les valeurs depuis l'URL
    let prep = this.pays? this.prep : 'en'
      const capitalizedCrypto = this.crypto.charAt(0).toUpperCase() + this.crypto.slice(1);
      const capitalizedPays = this.pays.charAt(0).toUpperCase() + this.pays.slice(1) || 'AFRIQUE';
      return `${this.action}  ${capitalizedCrypto} ${prep} ${capitalizedPays} - Hiropay`;
    },
    pageDescription() {
      // Générer une description dynamique
      
      const capitalizedCrypto = this.crypto.charAt(0).toUpperCase() + this.crypto.slice(1);
      const capitalizedPays = this.pays.charAt(0).toUpperCase() + this.pays.slice(1) || 'AFRIQUE';
      return `Découvrez Hiropay, la plateforme de confiance pour acheter, vendre et échanger des ${capitalizedCrypto} en Franc CFA (XOF) au ${capitalizedPays}. Profitez de services fiables et sécurisés adaptés à la région.`;
    },
    pageKeywords() {

      const capitalizedCrypto = this.crypto.charAt(0).toUpperCase() + this.crypto.slice(1);
      const capitalizedPays = this.pays.charAt(0).toUpperCase() + this.pays.slice(1) || 'AFRIQUE';
      return `${capitalizedCrypto} ${capitalizedPays}, Acheter ${capitalizedCrypto} ${capitalizedPays}, Vendre ${capitalizedCrypto} ${capitalizedPays}, Échanger ${capitalizedCrypto} ${capitalizedPays}, Cryptomonnaies XOF, Hiropay`;
    },
    pageOgUrl() {
      // Générer l'URL Open Graph
      return `https://www.hiropay.com${this.$route.path}`;
    }

    },

    metaInfo() {
    // Utiliser les computed properties pour les métadonnées
    return {
      title: this.pageTitle,
      meta: [
        {
          name: 'description',
          content: this.pageDescription
        },
        {
          name: 'keywords',
          content: this.pageKeywords
        },
        {
          property: 'og:title',
          content: this.pageTitle
        },
        {
          property: 'og:description',
          content: this.pageDescription
        },
        {
          property: 'og:image',
          content: 'https://hiropay.com/img/cryp.png' // Remplacez par une URL réelle
        },
        {
          property: 'og:url',
          content: this.pageOgUrl
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: this.pageTitle
        },
        {
          name: 'twitter:description',
          content: this.pageDescription
        },
        {
          name: 'twitter:image',
          content: 'https://hiropay.com/img/cryp.png' // Remplacez par une URL réelle
        }
      ]
    };
  },



    watch: {
  $route() {
    this.$meta().refresh();
  }
},

    methods: {
      animateButton() {
        this.isAnimating = true
        setTimeout(() => {
          this.isAnimating = false
        }, 150)
      }
    }
  }
  </script>
  
  <style scoped>
  .hero-section {
    position: relative;
    overflow: hidden;
    min-height: 100vh;
  }
  
 
  
  .v-card {
    position: relative;
    z-index: 2;
  }
  
  .flag-content {
    position: relative;
    padding-top: 66.67%; /* 3:2 aspect ratio */
    overflow: hidden;
  }
  
  .stripe {
    position: absolute;
    left: 0;
    right: 0;
    height: 20%;
  }
  
  .stripe:nth-child(1) { top: 0; }
  .stripe:nth-child(2) { top: 20%; }
  .stripe:nth-child(3) { top: 40%; }
  .stripe:nth-child(4) { top: 60%; }
  .stripe:nth-child(5) { top: 80%; }
  
  .green {
    background-color: #008000;
  }
  
  .yellow {
    background-color: #ffce00;
  }
  

  
  .btn-animate {
    transform: scale(0.95);
    opacity: 0.75;
  }
  
  .transparent {
    background-color: transparent !important;
  }
  </style>